// extracted by css-extract-rspack-plugin
export default {"page":"ContactUsV2-module__page"};